import {useQuery} from "react-query";
import {axiosInstances} from "../axios-instances";
import Cookies from "js-cookie";


export const GetOrders = ({ number }) => {
    return useQuery(['customers', number], async () => {
        const token = Cookies.get('token');
        if (!token) {
            throw new Error('Token is not available in localStorage');
        }
        const response = await axiosInstances.get('/amantrans/customer/order', {
            params: {
                city_id: 0,
                filial_id: 0,
                track_code: '',
                status: '',
                page: 0,
                per_page: number,
                sort_by: 'id',
                sort_by_ask: true,
            },
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    }, {
        onError: (error) => {
            console.error('Error fetching customers:', error);
        },
    });
};

export const searchOrderBy = async (trackCode) => {
    const response = await axiosInstances.get(`/amantrans/search-orders`, {
        params: {
            trackCode,
        },
    });

    if (response.status !== 200) {
        throw new Error(`Error: ${response.status}`);
    }
    return response.data;
};